/**
 * DOMI-CARE - Monitor de Signos Vitales y Semáforo Clínico
 */

export function renderVitalSignsGrid(latestSignos) {
  if (!latestSignos) {
    return `<div class="card" style="text-align: center; color: var(--text-muted); padding: 1.5rem;">
      No hay registros recientes de signos vitales para este paciente.
    </div>`;
  }

  // Lógica de clasificación clínica (Semaforización)
  const bpClass = (latestSignos.sistolica > 140 || latestSignos.sistolica < 90 || latestSignos.diastolica > 90) ? 'warning' : 'normal';
  const hrClass = (latestSignos.frecuenciaCardiaca > 100 || latestSignos.frecuenciaCardiaca < 55) ? 'warning' : 'normal';
  const spo2Class = (latestSignos.saturacionO2 < 92) ? 'danger' : (latestSignos.saturacionO2 < 95) ? 'warning' : 'normal';
  const tempClass = (latestSignos.temperatura >= 38.0) ? 'danger' : (latestSignos.temperatura >= 37.3) ? 'warning' : 'normal';
  const gluClass = (latestSignos.glucemia > 180 || latestSignos.glucemia < 70) ? 'warning' : 'normal';
  const evaClass = (latestSignos.dolorEVA >= 7) ? 'danger' : (latestSignos.dolorEVA >= 4) ? 'warning' : 'normal';

  return `
    <div class="vital-grid">
      <div class="vital-card ${bpClass}">
        <span class="vital-label">Tensión Arterial</span>
        <div class="vital-val">${latestSignos.sistolica || '--'}/${latestSignos.diastolica || '--'}</div>
        <span class="vital-unit">mmHg</span>
      </div>

      <div class="vital-card ${hrClass}">
        <span class="vital-label">Frecuencia Card.</span>
        <div class="vital-val">${latestSignos.frecuenciaCardiaca || '--'}</div>
        <span class="vital-unit">lpm (pulso)</span>
      </div>

      <div class="vital-card ${spo2Class}">
        <span class="vital-label">Sat. O2</span>
        <div class="vital-val">${latestSignos.saturacionO2 || '--'}%</div>
        <span class="vital-unit">pulsioximetría</span>
      </div>

      <div class="vital-card ${tempClass}">
        <span class="vital-label">Temperatura</span>
        <div class="vital-val">${latestSignos.temperatura || '--'}°C</div>
        <span class="vital-unit">axilar</span>
      </div>

      <div class="vital-card ${gluClass}">
        <span class="vital-label">Glucemia</span>
        <div class="vital-val">${latestSignos.glucemia || '--'}</div>
        <span class="vital-unit">mg/dL</span>
      </div>

      <div class="vital-card ${evaClass}">
        <span class="vital-label">Escala EVA</span>
        <div class="vital-val">${latestSignos.dolorEVA !== undefined ? latestSignos.dolorEVA : '--'}/10</div>
        <span class="vital-unit">intensidad dolor</span>
      </div>
    </div>
  `;
}
